import { EventTypeEnum } from 'modules/profile/notifications/enums/notification-settings-enum'

export const notificationSettingsLocoKeys: Record<EventTypeEnum, string> = {
  [EventTypeEnum.COMMENT_REPLY_ON_COMMENT]:
    'profile.user_settings.notifications.comment_reply_on_comment',
  [EventTypeEnum.COMMENT_ON_COMMUNITY_POST]:
    'profile.user_settings.notifications.comment_on_community_post',
  [EventTypeEnum.COMMENT_ON_COURSE_CREATED_BY_ME]:
    'profile.user_settings.notifications.comment_on_course_created_by_me',
  [EventTypeEnum.COMMUNITY_NEW_PENDING_POST]:
    'profile.user_settings.notifications.community_new_pending_post',
  [EventTypeEnum.COMMUNITY_POST_IS_PUBLISHED]:
    'profile.user_settings.notifications.community_post_published',
  [EventTypeEnum.COMMUNITY_POST_IS_LIKED]:
    'profile.user_settings.notifications.community_post_liked',
  [EventTypeEnum.COMMENT_IS_LIKED]: 'profile.user_settings.notifications.comment_is_liked',
  [EventTypeEnum.MENTION_IN_COMMENT_ON_COMMUNITY_POST]:
    'profile.user_settings.notifications.mention_in_comment_on_community_post',
  [EventTypeEnum.MENTION_IN_COMMUNITY_POST]:
    'profile.user_settings.notifications.mention_in_community_post',
}

export const notificationLocoKeys: Record<EventTypeEnum, string> = {
  [EventTypeEnum.COMMENT_REPLY_ON_COMMENT]: 'profile.notifications.comment_reply_on_comment',
  [EventTypeEnum.COMMENT_ON_COMMUNITY_POST]: 'profile.notifications.comment_on_community_post',
  [EventTypeEnum.COMMENT_ON_COURSE_CREATED_BY_ME]:
    'profile.notifications.comment_on_course_created_by_me',
  [EventTypeEnum.COMMUNITY_NEW_PENDING_POST]: 'profile.notifications.community_new_pending_post',
  [EventTypeEnum.COMMUNITY_POST_IS_PUBLISHED]: 'profile.notifications.community_post_published',
  [EventTypeEnum.COMMUNITY_POST_IS_LIKED]: 'profile.notifications.community_post_liked',
  [EventTypeEnum.COMMENT_IS_LIKED]: 'profile.notifications.comment_is_liked',
  [EventTypeEnum.MENTION_IN_COMMENT_ON_COMMUNITY_POST]:
    'profile.notifications.mention_in_comment_on_community_post',
  [EventTypeEnum.MENTION_IN_COMMUNITY_POST]: 'profile.notifications.mention_in_community_post',
}
